/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Map of reward config IDs to auto-claim booleans
 * @export
 * @interface RewardAutoSettingsMap
 */
export interface RewardAutoSettingsMap {
    [key: string]: boolean;
}

/**
 * Check if a given object implements the RewardAutoSettingsMap interface.
 */
export function instanceOfRewardAutoSettingsMap(value: object): value is RewardAutoSettingsMap {
    return true;
}

export function RewardAutoSettingsMapFromJSON(json: any): RewardAutoSettingsMap {
    return RewardAutoSettingsMapFromJSONTyped(json, false);
}

export function RewardAutoSettingsMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardAutoSettingsMap {
    return json;
}

export function RewardAutoSettingsMapToJSON(json: any): RewardAutoSettingsMap {
    return RewardAutoSettingsMapToJSONTyped(json, false);
}

export function RewardAutoSettingsMapToJSONTyped(value?: RewardAutoSettingsMap | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

